import React from 'react';
import { TripHistories, TripRequestType } from '@marageti/z4-sdk/lib/travel';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { useAuthStore } from '../../store';
import HomeView from './home-view';

const HomeContainer = () => {
  const { loggedInTraveler } = useAuthStore();
  const apiClient = useApiClient();
  const travelerId = loggedInTraveler?.id;

  const { data: tripsData, isLoading, error } = useFetch<TripHistories>(
    apiClient.peopleClient.getTravelerTripHistories,
    [travelerId],
    !!travelerId,
  );

  const activeTrips = tripsData?.activeTrips || [];
  const hasActiveLegacyTrips = activeTrips.some(
    (trip) => trip.tripRequestType === TripRequestType.Legacy,
  );

  return (
    <HomeView
      travelerId={travelerId || ''}
      activeTrips={activeTrips}
      pastTrips={tripsData?.pastTrips || []}
      archivedTrips={tripsData?.archivedTrips || []}
      reviewPromptTrips={tripsData?.reviewPromptTrips || []}
      loading={isLoading}
      error={error}
      showAnnouncementBanner
      hasActiveLegacyTrips={hasActiveLegacyTrips}
    />
  );
};

export default HomeContainer;
